(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-mobile"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  var modal = null;
  var modalImg = null;
  var currentIdx = 0;
  var imageData = [];
  var modalBound = false;

  function collectImages() {
    var all = document.querySelectorAll('.js-open-product-lightbox');
    var seen = Object.create(null);
    var result = [];

    all.forEach(function (img) {
      var id = img.dataset.imageId || img.src;
      if (!id || seen[id]) return;
      seen[id] = true;

      result.push({
        id: id,
        src: img.dataset.full || img.src,
        alt: img.getAttribute('alt') || ''
      });
    });

    imageData = result;
  }

  function showImage(index) {
    if (!imageData.length) return;

    currentIdx = (index + imageData.length) % imageData.length;
    var item = imageData[currentIdx];

    modalImg.style.opacity = '0';
    modalImg.src = item.src;
    modalImg.alt = item.alt;

    modalImg.onload = function () {
      modalImg.style.transition = 'opacity 0.18s';
      modalImg.style.opacity = '1';
    };

    if (modalImg.complete) {
      modalImg.style.opacity = '1';
    }
  }

  function openModal(index) {
    collectImages();
    showImage(index);
    modal.hidden = false;
    document.body.classList.add('product-lightbox-open');
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('product-lightbox-open');
    modalImg.src = '';
    modalImg.style.opacity = '1';
  }

  function bindGalleryImages() {
    var images = document.querySelectorAll('.js-open-product-lightbox');

    images.forEach(function (img) {
      if (img.dataset.lightboxBound) return;
      img.dataset.lightboxBound = 'true';

      img.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        collectImages();

        var id = img.dataset.imageId || img.src;
        var idx = imageData.findIndex(function (d) {
          return d.id === id;
        });

        if (idx === -1) idx = 0;

        openModal(idx);
      });
    });
  }

  function bindModal() {
    if (modalBound) return;
    modalBound = true;

    var closeBtn = modal.querySelector('.product-lightbox__close');
    var prevBtn = modal.querySelector('.product-lightbox__prev');
    var nextBtn = modal.querySelector('.product-lightbox__next');
    var content = modal.querySelector('.product-lightbox__content');

    closeBtn.addEventListener('click', closeModal);
    prevBtn.addEventListener('click', function () { showImage(currentIdx - 1); });
    nextBtn.addEventListener('click', function () { showImage(currentIdx + 1); });

    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target === content) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowRight') showImage(currentIdx + 1);
      if (e.key === 'ArrowLeft') showImage(currentIdx - 1);
    });

    var touchStartX = 0;

    modal.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });

    modal.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) < 40) return;
      showImage(diff > 0 ? currentIdx + 1 : currentIdx - 1);
    }, { passive: true });
  }

  function init() {
    modal = document.querySelector('.product-lightbox');
    if (!modal) return;

    modalImg = modal.querySelector('.product-lightbox__image');

    bindModal();
    bindGalleryImages();
  }

  function observeGallery() {
    var gallery = document.querySelector('.gallery__slider, product-media');
    if (!gallery) return;

    var mo = new MutationObserver(function () {
      bindGalleryImages();
    });

    mo.observe(gallery, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();
    observeGallery();
  });

  document.addEventListener('shopify:section:load', function () {
    init();
    observeGallery();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
